export const TICKET_SALES_ENABLED = false;
export const GROUP_REGISTRATION_ENABLED = false;

export const REGISTRATION_CLOSED_MESSAGE =
    'El registro de boletos y grupos ha finalizado. Gracias por tu interés.';
